import { INavigationElement } from 'global';
import { useMemo } from 'react';
import { NAVIGATION_ELEMENT_CONFIGS, NavigationExperiments } from './data';
import { NavigationType, TargetGroup } from './utils';
import { getNavigationConfigKey, processVariant } from './utils/experiment-helpers';

/**
 * Custom hook to process navigation elements with experiments
 */
export const useProcessedNavigationElements = (
  navigationElements: INavigationElement[] | undefined,
  experiments: NavigationExperiments
): INavigationElement[] | undefined => {
  return useMemo(() => {
    if (!navigationElements) return undefined;

    return navigationElements.map((element: INavigationElement) => {
      const type = element.fields?.type;
      const targetGroup = element.fields?.targetGroup;
      const petType = element.fields?.petType?.toLowerCase();

      // Find matching experiment configuration
      const config = NAVIGATION_ELEMENT_CONFIGS.find(
        (item) =>
          NavigationType[item.type] === type &&
          TargetGroup[item.targetGroup] === targetGroup &&
          item.petType === petType
      );

      if (config) {
        const experimentData = experiments[getNavigationConfigKey(config)];

        if (experimentData?.experiment.variant) {
          const processedVariant = processVariant(experimentData.experiment.variant, element);
          if (processedVariant) {
            return processedVariant;
          }
        }
      }

      return element;
    });
  }, [navigationElements, experiments]);
};
